






























































































import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";

import Clients from "@/API/Clients";
import Client from "@/ts/interfaces/Client";
import News from "@/ts/interfaces/Newsletter";
import ErrorStore from "@/ts/stores/ErrorStore";
import SnackbarStore from "@/ts/stores/SnackbarStore";

@Component({
    components: {
        MainNavigation
    },
})

export default class Newsletter extends Vue {
    search = '';
    selected: Client[] = [];
    subject = "";
    message = "";

    headers = [
        {
            text: 'Mandatenname',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Kurzbezeichnung',
            align: 'left',
            value: 'short_description'
        }
    ];
    clients: Client[] = [];

    //Lifecycle
    mounted() {
        Clients.getAllClients().then(res => {
            this.clients = res
        });

        //@ts-ignore:
        let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
        let packages = document.getElementById("icon-packages");
        let news = document.getElementById("icon-news");
        let settings = document.getElementById("icon-settings");

        //@ts-ignore:
        mandate.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        packages.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        settings.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        news.style = "color: #81B219";
    }

    //Methods/Functions
    sendNews() {
        let newsletter = new News("", "", []);
        let sendToAll = (document.getElementById("news-send-all") as HTMLInputElement).checked;
        let clientIds = this.gatherClientIds(sendToAll);

        newsletter.subject = this.subject;
        newsletter.message = this.message;
        newsletter.client_ids = clientIds;

        Clients.sendNewsletter(newsletter).then(res => {
            if (res.message.includes("sent")) {
                SnackbarStore.show("Erfolgreich versendet.")
            }
        }).catch(err => {
            ErrorStore.showError("Newsletter konnte nicht versendet werden.")
        });
    }

    gatherClientIds(sendToAll: boolean): number[] {
        let ids: number[] = [];

        if (sendToAll) {
            for (let i = 0; i < this.clients.length; i++) {
                ids.push(this.clients[i].team_id)
            }
        } else {
            for (let i = 0; i < this.selected.length; i++) {
                ids.push(this.selected[i].team_id)
            }
        }
        return ids
    }
}
